  <fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight] [crumbs]="['Settings', 'Copay Fee']"  current="Copay Fee Settings"></fury-breadcrumbs>
    </fury-page-layout-header>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
        <form [formGroup]="dynamicForm" *ngIf="!loading">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
          <div formArrayName="feeArray">
            <div *ngFor="let feeControl of feeArrayControls; let i=index" [formGroupName]="i">
              <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Copay Fee Amount</mat-label>
                <input matInput placeholder="Amount"  formControlName="amount" mask="separator.2" thousandSeparator="," separatorLimit="99999999999999">
                <mat-error *ngIf="feeControl.get('amount').hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Reflected Amount</mat-label>
                <input matInput placeholder="Reflected Amount"  formControlName="reflectedAmount" mask="separator.2" thousandSeparator="," separatorLimit="99999999999999" [allowNegativeNumbers]="true">
                <mat-error *ngIf="feeControl.get('reflectedAmount').hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <div style="padding-top: 15px;">
                <mat-checkbox formControlName="default">Default Select</mat-checkbox>
              </div>
            </div>
            <div formGroupName="status" class="status_sec">
              <mat-slide-toggle formControlName="monthly">Monthly</mat-slide-toggle>
              <mat-slide-toggle formControlName="yearly">Yearly</mat-slide-toggle>
              <mat-slide-toggle formControlName="twoYears">Two Years</mat-slide-toggle>
              <mat-slide-toggle formControlName="threeYears">Three Years</mat-slide-toggle>
              <mat-slide-toggle formControlName="fourYears">Four Years</mat-slide-toggle>
              <mat-slide-toggle formControlName="fiveYears">Five Years</mat-slide-toggle>
            </div> 
            </div>
          </div>
          </div>
        
          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button class="can-button" (click)="location?.back()" mat-button>Cancel</button>
            <button  class="sub-button" mat-button type="button" (click)="saveCopaySettings()">Update</button>
          </div>
        </form>
        <div *ngIf="loading">
          Please wait...
        </div>
      </div>
    </div>
  </fury-page-layout>